import { render, staticRenderFns } from "./formulate.vue?vue&type=template&id=abafb6ac&scoped=true&"
import script from "./formulate.vue?vue&type=script&lang=js&"
export * from "./formulate.vue?vue&type=script&lang=js&"
import style0 from "./formulate.vue?vue&type=style&index=0&id=abafb6ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abafb6ac",
  null
  
)

export default component.exports